import React from "react";

const SvgComponent = props => (
  <svg width="6.39em" height="1em" version={1} viewBox="0 0 464 77" {...props}>
    <g fill="currentColor">
      <path d="M256 14l-3-8h-15l-1 1v3l3 4h16zm43-8h-12l-2 1-3 7h16l3-6c1-1 0-2-1-2h-1zm23 0h-11l-2 2v6h15V7l-2-1zm72 8l-4-3c-5-4-12-6-19-6-9-1-18 3-25 9h48zm41 0l-4-8-2-1h-2l-1 2-3 7h12zm-215 0a35 35 0 0 0-47 0h47zm34 0h-17l5 11h16l-4-11zm3 45l7 14 2 1 2-1 1-3 6-11h-18zm21-34h12l6-11h-13l-5 11z" />
      <path d="M277 25h1l5-11h-4l-5 11zm29 34v12l2 2h12c1 0 2-1 1-2V59h-15zm0-45v11h15V14h-15zm62 5c5 0 10 2 13 5 2 1 3 0 4-1l6-7c1-1 0-2-1-2h-46l-8 11h19c3-4 8-6 13-6zm20 40h-49a35 35 0 0 0 52 5c1-1 0-2-1-3l-2-2zm70 11l-5-11h-54l-5 12c-1 2 2 2 3 2h10l4-5 2-5h26l4 9 6 1h8c1 0 2-2 1-3zm-26-56h-12l-5 11h22l-5-11zm-238 6c4 0 9 2 12 5h19l-8-11h-47c-3 3-6 7-7 11h19c3-3 7-5 12-5zm3 39h-32c6 9 16 15 27 15 11 1 22-4 29-13 0-1 3-3 1-2h-25zm74-17c-1 0-1-2-2-1l-1-1-7-15h-16l15 34h17l16-34h-15l-7 17z" />
      <path d="M271 42l7-17h-1l-7 16v1zm38 17h15V25h-15v34zm82 0l-5-5c-3-1-4 2-7 3-7 3-15 2-21-4-7-6-8-18-2-26 1-1 2-2 0-2h-17c-5 11-4 24 3 34h49zm30-9l8-16 1 3 6 13h-15zm34 9l-15-34h-22l-16 34h53zm-261 0c-8-1-14-7-16-15-2-7 1-14 6-19h-19c-5 11-4 24 3 34h26zm31-34h-16c5 5 8 12 6 19-2 8-8 14-16 15h26c7-10 8-23 3-34h-3zM83 7c0-1-2-2-4-1H69c-2 0-1 2-1 4l-2 7c-1 3-1 7 1 10s-1 6-3 8c-4 3-10 1-12-3l-2-6c-2-3-2-8-1-11l2-6c0-1 0-3-2-3H37l-1 4-2 7c-1 4 0 7 2 10l1 7c2 9 11 16 20 17a23 23 0 0 0 25-23l-2-7c0-3 0-6 2-9l1-5z" />
      <path d="M48 59l-4-1H25V29l-3-9 2-8 1-5c-1-2-3-2-5-2h-9c-2 1-1 3-1 4 0 3-3 5-3 8-1 4 0 7 2 11l1 8v18c-1 3-4 5-3 9v8c1 2 3 1 5 1h36c2 0 1-3 1-4v-8l-1-1zm71 0h-9V29c0-3-3-6-2-9h13l9 5 4 1c7 9 5 24-5 30-3 2-6 3-10 3zm33-32c-1-3-5-4-6-6l-4-8c-7-5-15-8-24-7H97c-3 1-1 5-3 7-2 4-2 10 1 14v24c-1 3-3 6-2 9v11c0 2 2 2 4 2h23c10-1 20-6 25-14 2 0 4 0 4-2 6-9 7-21 3-30z" />
      <text
        className="sous-titre"
        x={54}
        y={76}
        fill="#000"
        fontSize={29}
        fontFamily="'DIN-Alternate-Bold',arial-black"
      >
        une ville en fragments
      </text>
    </g>
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/logo-ludovica.svg